import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  closeModals() {
    window.$("#suiModal").modal("hide");
  }

  connect() {
    if (typeof window.initTroubleshooters === "function") {
      window.initTroubleshooters();
    }
  }
}
